<template>
  <v-container fluid>
    <v-layout 
      row 
      wrap>
      <h1 v-if = "selectedIntent && selectedIntent.name"> Intents <span class="primary--text">({{ selectedIntent.name }})</span></h1>
      <v-spacer />
      <app-actions />
    </v-layout>
    <v-flex xs12>
      <intent-samples v-if = "selectedIntent && selectedIntent.name"/>
    </v-flex>
    <v-flex xs12>
      <intent-features v-if = "selectedIntent && selectedIntent.name"/>
    </v-flex>
    <v-flex xs12>
      <entity-extraction v-if = "selectedIntent && selectedIntent.name"/>
    </v-flex>
  </v-container>
</template>

<script>
import IntentSamples from '../../intents/IntentSamples'
import AppActions from '../../common/AppActions'
import entityExtraction from "../../intents/entityExtraction";
import IntentFeatures from "../../intents/IntentFeatures";
export default {
  name: 'Single',
  components: {
    IntentSamples,
    AppActions,
    entityExtraction,
    IntentFeatures
  },
  data() {
    return {}
  },
  computed: {
    selectedIntent() {
      return this.$store.state.nlp.selectedIntent
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getIntent()
      this.getEntities()
    },
    async getIntent() {
      await this.$store.dispatch(
        'nlp/intents/get/single',
        this.$route.params.intent
      )
    },
    getEntities() {
      this.$store.dispatch('nlp/entities/get', null)
      .then(() => {})
      .catch(err => {
        this.$store.dispatch('setErrorMessage', true)
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
